import './Navigation.css.proxy.js';
/* src/components/navigation/Navigation.svelte generated by Svelte v3.35.0 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	component_subscribe,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	listen,
	mount_component,
	safe_not_equal,
	toggle_class,
	transition_in,
	transition_out
} from "../../web_modules/svelte/internal.js";

import { folded } from "../../_stores/navigation.js";
import Link from "./Link.js";

function create_fragment(ctx) {
	let nav;
	let ul;
	let li0;
	let link0;
	let li1;
	let link1;
	let li2;
	let link2;
	let li3;
	let link3;
	let li4;
	let link4;
	let li5;
	let link5;
	let li6;
	let link6;
	let li7;
	let link7;
	let current;
	let mounted;
	let dispose;

	link0 = new Link({
			props: { to: "/", name: "ホーム", en: "HOME" }
		});

	link1 = new Link({
			props: { to: "/stock", name: "車両一覧", en: "STOCK" }
		});

	link2 = new Link({
			props: {
				to: "/inspection",
				name: "点検サービス",
				en: "INSPECTION"
			}
		});

	link3 = new Link({
			props: {
				to: "/rental",
				name: "スーパーカーレンタル",
				en: "RENTAL"
			}
		});

	link4 = new Link({
			props: { to: "/about", name: "企業情報", en: "ABOUT" }
		});

	link5 = new Link({
			props: { to: "/news", name: "お知らせ", en: "NEWS" }
		});

	link6 = new Link({
			props: {
				to: "/recruit",
				name: "求人情報",
				en: "RECRUIT"
			}
		});

	link7 = new Link({
			props: {
				to: "/contact",
				name: "お問い合わせ",
				en: "CONTACT"
			}
		});

	return {
		c() {
			nav = element("nav");
			ul = element("ul");
			li0 = element("li");
			create_component(link0.$$.fragment);
			li1 = element("li");
			create_component(link1.$$.fragment);
			li2 = element("li");
			create_component(link2.$$.fragment);
			li3 = element("li");
			create_component(link3.$$.fragment);
			li4 = element("li");
			create_component(link4.$$.fragment);
			li5 = element("li");
			create_component(link5.$$.fragment);
			li6 = element("li");
			create_component(link6.$$.fragment);
			li7 = element("li");
			create_component(link7.$$.fragment);
			this.h();
		},
		l(nodes) {
			nav = claim_element(nodes, "NAV", { class: true });
			var nav_nodes = children(nav);
			ul = claim_element(nav_nodes, "UL", { class: true });
			var ul_nodes = children(ul);
			li0 = claim_element(ul_nodes, "LI", { class: true });
			var li0_nodes = children(li0);
			claim_component(link0.$$.fragment, li0_nodes);
			li0_nodes.forEach(detach);
			li1 = claim_element(ul_nodes, "LI", { class: true });
			var li1_nodes = children(li1);
			claim_component(link1.$$.fragment, li1_nodes);
			li1_nodes.forEach(detach);
			li2 = claim_element(ul_nodes, "LI", { class: true });
			var li2_nodes = children(li2);
			claim_component(link2.$$.fragment, li2_nodes);
			li2_nodes.forEach(detach);
			li3 = claim_element(ul_nodes, "LI", { class: true });
			var li3_nodes = children(li3);
			claim_component(link3.$$.fragment, li3_nodes);
			li3_nodes.forEach(detach);
			li4 = claim_element(ul_nodes, "LI", { class: true });
			var li4_nodes = children(li4);
			claim_component(link4.$$.fragment, li4_nodes);
			li4_nodes.forEach(detach);
			li5 = claim_element(ul_nodes, "LI", { class: true });
			var li5_nodes = children(li5);
			claim_component(link5.$$.fragment, li5_nodes);
			li5_nodes.forEach(detach);
			li6 = claim_element(ul_nodes, "LI", { class: true });
			var li6_nodes = children(li6);
			claim_component(link6.$$.fragment, li6_nodes);
			li6_nodes.forEach(detach);
			li7 = claim_element(ul_nodes, "LI", { class: true });
			var li7_nodes = children(li7);
			claim_component(link7.$$.fragment, li7_nodes);
			li7_nodes.forEach(detach);
			ul_nodes.forEach(detach);
			nav_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(li0, "class", "svelte-9h3crz");
			attr(li1, "class", "svelte-9h3crz");
			attr(li2, "class", "svelte-9h3crz");
			attr(li3, "class", "svelte-9h3crz");
			attr(li4, "class", "svelte-9h3crz");
			attr(li5, "class", "svelte-9h3crz");
			attr(li6, "class", "svelte-9h3crz");
			attr(li7, "class", "svelte-9h3crz");
			attr(ul, "class", "svelte-9h3crz");
			attr(nav, "class", "svelte-9h3crz");
			toggle_class(nav, "folded", /*$folded*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, nav, anchor);
			append(nav, ul);
			append(ul, li0);
			mount_component(link0, li0, null);
			append(ul, li1);
			mount_component(link1, li1, null);
			append(ul, li2);
			mount_component(link2, li2, null);
			append(ul, li3);
			mount_component(link3, li3, null);
			append(ul, li4);
			mount_component(link4, li4, null);
			append(ul, li5);
			mount_component(link5, li5, null);
			append(ul, li6);
			mount_component(link6, li6, null);
			append(ul, li7);
			mount_component(link7, li7, null);
			current = true;

			if (!mounted) {
				dispose = listen(nav, "click", folded.fold);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*$folded*/ 1) {
				toggle_class(nav, "folded", /*$folded*/ ctx[0]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(link0.$$.fragment, local);
			transition_in(link1.$$.fragment, local);
			transition_in(link2.$$.fragment, local);
			transition_in(link3.$$.fragment, local);
			transition_in(link4.$$.fragment, local);
			transition_in(link5.$$.fragment, local);
			transition_in(link6.$$.fragment, local);
			transition_in(link7.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(link0.$$.fragment, local);
			transition_out(link1.$$.fragment, local);
			transition_out(link2.$$.fragment, local);
			transition_out(link3.$$.fragment, local);
			transition_out(link4.$$.fragment, local);
			transition_out(link5.$$.fragment, local);
			transition_out(link6.$$.fragment, local);
			transition_out(link7.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(nav);
			destroy_component(link0);
			destroy_component(link1);
			destroy_component(link2);
			destroy_component(link3);
			destroy_component(link4);
			destroy_component(link5);
			destroy_component(link6);
			destroy_component(link7);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $folded;
	component_subscribe($$self, folded, $$value => $$invalidate(0, $folded = $$value));
	return [$folded];
}

class Navigation extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Navigation;
//# sourceMappingURL=Navigation.js.map
